import React, { useContext } from 'react'
import { ChangePresentContext, PostEventAnalysisContext } from '../SingleEvent'
import TextField from '@mui/material/TextField'

const PEAClientFeedback = () => {
  const { postEventAnalysis, setPostEventAnalysis } = useContext(
    PostEventAnalysisContext
  )
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <TextField
      multiline
      minRows={2}
      value={postEventAnalysis?.clientFeedback}
      onChange={(e) => {
        setPostEventAnalysis((prev) => ({
          ...prev,
          clientFeedback: e.target.value,
        }))
        !changesPresent && setChangesPresent(true)
      }}
      label="Client Feedback"
    />
  )
}

export default React.memo(PEAClientFeedback)
